import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { stockDeliveryApprovalParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  stockDeliveryApprovalResponse,
  stockDeliveryApprovalRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum StockDeliveryApprovalState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: StockDeliveryApprovalState;
  message: string;
}

const initialState: InitialState = {
  status: StockDeliveryApprovalState.initial,
  message: "",
};

export const stockDeliveryApproval = createAsyncThunk(
  "stockDeliveryApproval",
  async (param: stockDeliveryApprovalParam, { rejectWithValue }) => {
    try {
      const response: stockDeliveryApprovalResponse =
        await stockDeliveryApprovalRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const stockDeliveryApprovalSlice = createSlice({
  name: "stockDeliveryApproval",
  initialState,
  reducers: {
    resetstockDeliveryApproval: (state) => {
      state.status = StockDeliveryApprovalState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(stockDeliveryApproval.pending, (state) => {
        state.status = StockDeliveryApprovalState.inProgress;
      })
      .addCase(stockDeliveryApproval.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = StockDeliveryApprovalState.success;
          state.message = message;
        }
      })
      .addCase(stockDeliveryApproval.rejected, (state, action) => {
        state.status = StockDeliveryApprovalState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectStockDeliveryApproval = (state: RootState) =>
  state.stockDeliveryApproval;

export const { resetstockDeliveryApproval } =
  stockDeliveryApprovalSlice.actions;
export default stockDeliveryApprovalSlice.reducer;
